<template>
  <CustomDeleteDialog
    dialogTitle="افزودن کاربر به لیست مسدودی"
    dialogId="add-user-to-blocklist"
    okTitle="مسدود سازی کاربر"
    no-close-on-backdrop
    :isOkDisabled="isOkButtonDisabled || !blockUserPayload.studentId"
    @ok="sendBlockRequest"
  >
    <BCol cols="12">
      <StudentPicker isInDialog @getStudentUserId="setStudentUserId"></StudentPicker>
    </BCol>
  </CustomDeleteDialog>
</template>

<script>
export default {
  emits: ["refetch"],
  data() {
    return {
      blockUserPayload: {
        masterId: null,
        studentId: null,
      },
      isOkButtonDisabled: false,
    };
  },
  methods: {
    setStudentUserId(userId) {
      this.blockUserPayload.studentId = userId;
    },
    async sendBlockRequest() {
      try {
        if (getUserData() && getUserData().user && getUserData().user.userId) {
          this.blockUserPayload.masterId = getUserData().user.userId;
        }
        this.isOkButtonDisabled = true;
        let _this = this;
        let blockUserByMaster = new BlockUserByMaster(_this);
        blockUserByMaster.setRequestParam(_this.blockUserPayload);
        await blockUserByMaster.fetch((res) => {
          if (res.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "مسدود شد!",
                icon: "CheckIcon",
                variant: "success",
                text: "کاربر با موفقیت مسدود شد.",
              },
            });
            _this.blockUserPayload = {
              masterId: null,
              studentId: null,
            };
            this.$bvModal.hide("add-user-to-blocklist");
            _this.$emit("refetch");
          } else {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "مسدود نشد!",
                icon: "XIcon",
                variant: "danger",
                text: res.errors || "مشکلی پیش آمد، لطفا دوباره امتحان کنید",
              },
            });
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isOkButtonDisabled = false;
      }
    },
  },
  components: {
    BCol,
    CustomDeleteDialog,
    StudentPicker,
  },
};
import CustomDeleteDialog from "@/views/components/Utils/Dialogs/CustomDeleteDialog.vue";
import StudentPicker from "@/views/components/Students/StudentPicker.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import { BlockUserByMaster } from "@/libs/Api/Users";
import { BCol } from "bootstrap-vue";
import { getUserData } from "@/auth/utils";
</script>
